import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=3804d498"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports